var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length===0)?_c('p',{staticClass:"text-center p-3"},[_vm._v("No data available.")]):_c('ul',{staticClass:"custom-ul-list solution-cont font-inter-medium"},_vm._l((_vm.items),function(item,i){return _c('li',{key:i},[_c('p',{staticClass:"pl-4"},[_vm._v(_vm._s(item))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }